import { render } from "./RecipeSubscription.vue?vue&type=template&id=510d6242&scoped=true"
import script from "./RecipeSubscription.vue?vue&type=script&lang=js"
export * from "./RecipeSubscription.vue?vue&type=script&lang=js"

import "./RecipeSubscription.vue?vue&type=style&index=0&id=510d6242&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510d6242"],['__file',"src/views/paywall/RecipeSubscription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "510d6242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('510d6242', __exports__)) {
    console.log('reload')
    api.reload('510d6242', __exports__)
  }
  
  module.hot.accept("./RecipeSubscription.vue?vue&type=template&id=510d6242&scoped=true", () => {
    console.log('re-render')
    api.rerender('510d6242', render)
  })

}


export default __exports__